import { render, staticRenderFns } from "./Addendum.vue?vue&type=template&id=9bd75030&scoped=true&"
import script from "./Addendum.vue?vue&type=script&lang=js&"
export * from "./Addendum.vue?vue&type=script&lang=js&"
import style0 from "./Addendum.vue?vue&type=style&index=0&id=9bd75030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd75030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd75030')) {
      api.createRecord('9bd75030', component.options)
    } else {
      api.reload('9bd75030', component.options)
    }
    module.hot.accept("./Addendum.vue?vue&type=template&id=9bd75030&scoped=true&", function () {
      api.rerender('9bd75030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/Addendum.vue"
export default component.exports